/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_OfflineInputs */

const en_import_offline = /** @type {(inputs: Import_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're offline. Imports need a connection.`)
};

const de_import_offline = /** @type {(inputs: Import_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist offline. Importe brauchen eine Verbindung.`)
};

/**
* | output |
* | --- |
* | "You're offline. Imports need a connection." |
*
* @param {Import_OfflineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_offline = /** @type {((inputs?: Import_OfflineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_OfflineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_offline(inputs)
	return en_import_offline(inputs)
});